<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  .mapping-grid {
    display: grid;
    gap: utils.in_rem(25px);
    padding: utils.in_rem(32px) 0 utils.in_rem(32px) utils.in_rem(50px);

    .map {
      display: grid;
      gap: utils.in_rem(12px);
    }

    .note-header {
      @include mixins.h3();
      padding-top: utils.in_rem(16px);
    }

    .show-more {
      display: flex;
      justify-content: center;
      justify-self: center;
      width: fit-content;
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import SettingMappingRow from "../../../components/shared/MappingGrid/SettingMappingRow.svelte";

  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import { integrationStore } from "../../../stores";
  import { STEP_TYPES } from "../constants";
  import { activeNoteType, filteredSettings } from "../utils";

  export let type;
  export let settings = [];

  $: targetLabel = $integrationStore.getProviderTitle();
  $: createNotesUpon = $integrationStore.getValue("createNotesUpon");
  $: popularSettings = filteredSettings(settings, "popular", type);

  let showMore = false;
  const handleShowMore = () => {
    showMore = !showMore;
  };
</script>

<div class="mapping-grid">
  <SettingMappingRow sourceLabel="SourceWhale" {targetLabel} header />
  {#if settings.length}
    <div class="map">
      {#if popularSettings.length > 0}
        {#each popularSettings as setting}
          <SettingMappingRow
            {setting}
            {type}
            disabled={!activeNoteType(createNotesUpon, setting.key, type)}
          />
        {/each}
      {/if}

      {#if showMore}
        {#each Object.keys(STEP_TYPES) as step}
          <!-- Hide sms steps if user does not have sms enabled -->
          {#if step !== "popular" && (step !== "phone" || $userStore?.hasSms)}
            {@const stepTypeSettings = filteredSettings(settings, step, type)}
            {#if stepTypeSettings.length > 0}
              <span class="note-header">{STEP_TYPES[step].title}</span>
              {#each stepTypeSettings as setting}
                <SettingMappingRow
                  {setting}
                  {type}
                  disabled={!activeNoteType(createNotesUpon, setting.key, type)}
                />
              {/each}
            {/if}
          {/if}
        {/each}
      {/if}
      <div class="show-more">
        <Button
          onclick={handleShowMore}
          kind="ghost-blue"
          leadingIcon={showMore ? "" : "far fa-plus"}
        >
          {#if showMore}
            Show less
          {:else}
            Show more
          {/if}
        </Button>
      </div>
    </div>
  {/if}
</div>
